<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 table-responsive">
          <!-- CHART OVERLAY -->
          <div v-if="showChart" class="chart-overlay" @click.self="showChart = false">
              <div class="chart-modal">
                  <div class="chart-modal-header">
                      <span><i class="fas fa-chart-bar me-2"></i>Gráfico Neuromotor - Saltos</span>
                      <button class="btn-chart-close" @click="showChart = false"><i class="fas fa-times"></i></button>
                  </div>
                  <div class="chart-modal-body">
                      <canvas ref="neuroChartCanvas"></canvas>
                  </div>
              </div>
          </div>

          <!-- TIME CHART OVERLAY -->
          <div v-if="showTimeChart" class="chart-overlay" @click.self="showTimeChart = false">
              <div class="chart-modal">
                  <div class="chart-modal-header">
                      <span><i class="fas fa-chart-bar me-2"></i>Gráfico Neuromotor - Medidas de Tempo</span>
                      <button class="btn-chart-close" @click="showTimeChart = false"><i class="fas fa-times"></i></button>
                  </div>
                  <div class="chart-modal-body">
                      <canvas ref="timeChartCanvas"></canvas>
                  </div>
              </div>
          </div>

          <table class="table border table-striped text-center text-sm table-sm neuro-table">
            <thead>
              <tr class="font-weight-bold">
                <td class="text-start w-25 p-2 align-middle">
                  {{ $t('timeMeasures') }}
                  <button class="btn-chart-toggle-sm ms-2" @click="showTimeChart = !showTimeChart" title="Ver gráfico">
                    <i class="fas fa-chart-bar"></i>
                  </button>
                </td>
                <td class="text-start w-15 p-2 align-middle">{{ $t('currentTime') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('firstTime') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('previousTime') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('diffCurrentPreviousTime') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('diffCurrentFirstTime') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-start">50 {{ $t('meters') }}</td>
                <td class="text-start">
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['50m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['50m'] }}</td>
                <td>{{ state.neuroMotorAnterior['50m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['50m'],
                      state.neuroMotorAnterior['50m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['50m'],
                      state.neuroMotorPrimeiro['50m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">60 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['60m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['60m'] }}</td>
                <td>{{ state.neuroMotorAnterior['60m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['60m'],
                      state.neuroMotorAnterior['60m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['60m'],
                      state.neuroMotorPrimeiro['60m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">100 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['100m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['100m'] }}</td>
                <td>{{ state.neuroMotorAnterior['100m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['100m'],
                      state.neuroMotorAnterior['100m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['100m'],
                      state.neuroMotorPrimeiro['100m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">200 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['200m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['200m'] }}</td>
                <td>{{ state.neuroMotorAnterior['200m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['200m'],
                      state.neuroMotorAnterior['200m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['200m'],
                      state.neuroMotorPrimeiro['200m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">300 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['300m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['300m'] }}</td>
                <td>{{ state.neuroMotorAnterior['300m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['300m'],
                      state.neuroMotorAnterior['300m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['300m'],
                      state.neuroMotorPrimeiro['300m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">400 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['400m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['400m'] }}</td>
                <td>{{ state.neuroMotorAnterior['400m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['400m'],
                      state.neuroMotorAnterior['400m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['400m'],
                      state.neuroMotorPrimeiro['400m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">600 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['600m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['600m'] }}</td>
                <td>{{ state.neuroMotorAnterior['600m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['600m'],
                      state.neuroMotorAnterior['600m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['600m'],
                      state.neuroMotorPrimeiro['600m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">800 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['800m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['800m'] }}</td>
                <td>{{ state.neuroMotorAnterior['800m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['800m'],
                      state.neuroMotorAnterior['800m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['800m'],
                      state.neuroMotorPrimeiro['800m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">1000 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['1000m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['1000m'] }}</td>
                <td>{{ state.neuroMotorAnterior['1000m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['1000m'],
                      state.neuroMotorAnterior['1000m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['1000m'],
                      state.neuroMotorPrimeiro['1000m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">1500 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['1500m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['1500m'] }}</td>
                <td>{{ state.neuroMotorAnterior['1500m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['1500m'],
                      state.neuroMotorAnterior['1500m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['1500m'],
                      state.neuroMotorPrimeiro['1500m'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">5000 {{ $t('meters') }}</td>
                <td>
                  <input
                    type="text"
                    v-maska="'##:##'"
                    class="w-50 form-control form-control-sm neuro-input"
                    v-model="state.neuroMotorAtual['5000m']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['5000m'] }}</td>
                <td>{{ state.neuroMotorAnterior['5000m'] }}</td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['5000m'],
                      state.neuroMotorAnterior['5000m'],
                    )
                  }}
                </td>
                <td>
                  {{
                    $filters.diffTimeMinutesSeconds(
                      state.neuroMotorAtual['5000m'],
                      state.neuroMotorPrimeiro['5000m'],
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>

          <table class="table border mt-5 table-striped text-center text-sm table-sm neuro-table">
            <thead>
              <tr class="neuro-saltos-header">
                <td colspan="6" class="py-2">
                  <span class="font-weight-bold">{{ $t('jumps') }}</span>
                  <span class="small">(Vertical: cm | Horizontal: m)</span>
                  <button class="btn-chart-toggle-saltos ms-2" @click="showChart = !showChart" title="Ver gráfico">
                    <i class="fas fa-chart-bar"></i>
                  </button>
                </td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-start w-25 p-2 align-middle"></td>
                <td class="text-start w-15 p-2 align-middle">{{ $t('current') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('firstJump') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('previousJump') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('diffCurrentPreviousJump') }}</td>
                <td class="w-15 p-2 align-middle">{{ $t('diffCurrentFirstJump') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-start">{{ $t('freeVerticalJump') }}</td>
                <td class="text-start">
                  <input
                    type="text"
                    class="w-50 form-control form-control-sm neuro-input"
                    @input="formatarSaltoVertical($event, 'free_vertical_jump')"
                    v-model="state.neuroMotorAtual['free_vertical_jump']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['free_vertical_jump'] }}</td>
                <td>{{ state.neuroMotorAnterior['free_vertical_jump'] }}</td>
                <td>
                  {{
                    calcularDiferenca(
                      state.neuroMotorAtual['free_vertical_jump'],
                      state.neuroMotorAnterior['free_vertical_jump'],
                    )
                  }}
                </td>
                <td>
                  {{
                    calcularDiferencaPrimeiro(
                      state.neuroMotorAtual['free_vertical_jump'],
                      state.neuroMotorPrimeiro['free_vertical_jump'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('verticalBoxJump') }}</td>
                <td>
                  <input
                    type="text"
                    class="w-50 form-control form-control-sm neuro-input"
                    @input="formatarSaltoVertical($event, 'vertical_box_jump')"
                    v-model="state.neuroMotorAtual['vertical_box_jump']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['vertical_box_jump'] }}</td>
                <td>{{ state.neuroMotorAnterior['vertical_box_jump'] }}</td>
                <td>
                  {{
                    calcularDiferenca(
                      state.neuroMotorAtual['vertical_box_jump'],
                      state.neuroMotorAnterior['vertical_box_jump'],
                    )
                  }}
                </td>
                <td>
                  {{
                    calcularDiferencaPrimeiro(
                      state.neuroMotorAtual['vertical_box_jump'],
                      state.neuroMotorPrimeiro['vertical_box_jump'],
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-start">{{ $t('horizontalJump') }}</td>
                <td>
                  <input
                    type="text"
                    class="w-50 form-control form-control-sm neuro-input"
                    @input="formatarSaltoHorizontal($event, 'horizontal_jump')"
                    v-model="state.neuroMotorAtual['horizontal_jump']"
                  />
                </td>
                <td>{{ state.neuroMotorPrimeiro['horizontal_jump'] }}</td>
                <td>{{ state.neuroMotorAnterior['horizontal_jump'] }}</td>
                <td>
                  {{
                    calcularDiferenca(
                      state.neuroMotorAtual['horizontal_jump'],
                      state.neuroMotorAnterior['horizontal_jump'],
                    )
                  }}
                </td>
                <td>
                  {{
                    calcularDiferencaPrimeiro(
                      state.neuroMotorAtual['horizontal_jump'],
                      state.neuroMotorPrimeiro['horizontal_jump'],
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 text-end">
          <router-link to="/avaliacao-fisica">
            <button type="button" class="btn bg-gradient-secondary">Voltar</button>
          </router-link>
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import neuroMotorRepository from '../../../../../services/api/neuroMotorRepository'
import { useRouter, useRoute } from 'vue-router'
import { Money3Component } from 'v-money3'
import NeuroMotorModel from '@/models/neuroMotorModel'
import Chart from 'chart.js/auto'

export default {
  components: {
    money3: Money3Component,
  },
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      state.avaliacaoId = props.avaliacaoIdProp
      buscarDados()
    })

    const state = reactive({
      avaliacaoId: 0,
      neuroMotorAtual: new NeuroMotorModel(),
      neuroMotorAnterior: new NeuroMotorModel(),
      neuroMotorPrimeiro: new NeuroMotorModel(),
    })

    async function buscarDados() {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        if (state.avaliacaoId == 0) {
          let responseFirst = await neuroMotorRepository.PrimeiroNeuroMotorGet()
          let responseLast = await neuroMotorRepository.UltimoNeuroMotorGet()
          store.commit('SET_SPLASH_SCREEN', false)

          if (responseFirst.data.success && responseFirst.data.data != null) {
            state.neuroMotorPrimeiro = responseFirst.data.data
            // Converter ponto para vírgula nos campos de salto para exibição no frontend
            if (state.neuroMotorPrimeiro.free_vertical_jump) {
              state.neuroMotorPrimeiro.free_vertical_jump = state.neuroMotorPrimeiro.free_vertical_jump
                .toString()
                .replace('.', ',')
            }
            if (state.neuroMotorPrimeiro.vertical_box_jump) {
              state.neuroMotorPrimeiro.vertical_box_jump = state.neuroMotorPrimeiro.vertical_box_jump
                .toString()
                .replace('.', ',')
            }
            if (state.neuroMotorPrimeiro.horizontal_jump) {
              state.neuroMotorPrimeiro.horizontal_jump = state.neuroMotorPrimeiro.horizontal_jump
                .toString()
                .replace('.', ',')
            }
          }
          if (responseLast.data.success && responseLast.data.data != null) {
            state.neuroMotorAnterior = responseLast.data.data
            // Converter ponto para vírgula nos campos de salto para exibição no frontend
            if (state.neuroMotorAnterior.free_vertical_jump) {
              state.neuroMotorAnterior.free_vertical_jump = state.neuroMotorAnterior.free_vertical_jump
                .toString()
                .replace('.', ',')
            }
            if (state.neuroMotorAnterior.vertical_box_jump) {
              state.neuroMotorAnterior.vertical_box_jump = state.neuroMotorAnterior.vertical_box_jump
                .toString()
                .replace('.', ',')
            }
            if (state.neuroMotorAnterior.horizontal_jump) {
              state.neuroMotorAnterior.horizontal_jump = state.neuroMotorAnterior.horizontal_jump
                .toString()
                .replace('.', ',')
            }
          }
        } else {
          let response = await neuroMotorRepository.NeuroMotorGetByAssessmentId(state.avaliacaoId)
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            if (response.data.data.item != null) {
              state.neuroMotorAtual = Object.assign(new NeuroMotorModel(), response.data.data.item)
              // Converter ponto para vírgula nos campos de salto para exibição no frontend
              if (state.neuroMotorAtual.free_vertical_jump) {
                state.neuroMotorAtual.free_vertical_jump = state.neuroMotorAtual.free_vertical_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorAtual.vertical_box_jump) {
                state.neuroMotorAtual.vertical_box_jump = state.neuroMotorAtual.vertical_box_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorAtual.horizontal_jump) {
                state.neuroMotorAtual.horizontal_jump = state.neuroMotorAtual.horizontal_jump
                  .toString()
                  .replace('.', ',')
              }
            }
            if (response.data.data.before != null) {
              state.neuroMotorAnterior = Object.assign(
                new NeuroMotorModel(),
                response.data.data.before,
              )
              // Converter ponto para vírgula nos campos de salto para exibição no frontend
              if (state.neuroMotorAnterior.free_vertical_jump) {
                state.neuroMotorAnterior.free_vertical_jump = state.neuroMotorAnterior.free_vertical_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorAnterior.vertical_box_jump) {
                state.neuroMotorAnterior.vertical_box_jump = state.neuroMotorAnterior.vertical_box_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorAnterior.horizontal_jump) {
                state.neuroMotorAnterior.horizontal_jump = state.neuroMotorAnterior.horizontal_jump
                  .toString()
                  .replace('.', ',')
              }
            }
            if (response.data.data.first != null) {
              state.neuroMotorPrimeiro = Object.assign(
                new NeuroMotorModel(),
                response.data.data.first,
              )
              // Converter ponto para vírgula nos campos de salto para exibição no frontend
              if (state.neuroMotorPrimeiro.free_vertical_jump) {
                state.neuroMotorPrimeiro.free_vertical_jump = state.neuroMotorPrimeiro.free_vertical_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorPrimeiro.vertical_box_jump) {
                state.neuroMotorPrimeiro.vertical_box_jump = state.neuroMotorPrimeiro.vertical_box_jump
                  .toString()
                  .replace('.', ',')
              }
              if (state.neuroMotorPrimeiro.horizontal_jump) {
                state.neuroMotorPrimeiro.horizontal_jump = state.neuroMotorPrimeiro.horizontal_jump
                  .toString()
                  .replace('.', ',')
              }
            }
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      }
    }

    function salvar() {
      try {
        // Converter vírgula para ponto nos campos de salto (formato brasileiro para formato internacional)
        if (
          state.neuroMotorAtual.free_vertical_jump &&
          typeof state.neuroMotorAtual.free_vertical_jump === 'string'
        ) {
          state.neuroMotorAtual.free_vertical_jump = state.neuroMotorAtual.free_vertical_jump.replace(
            ',',
            '.',
          )
        }
        if (
          state.neuroMotorAtual.vertical_box_jump &&
          typeof state.neuroMotorAtual.vertical_box_jump === 'string'
        ) {
          state.neuroMotorAtual.vertical_box_jump = state.neuroMotorAtual.vertical_box_jump.replace(
            ',',
            '.',
          )
        }
        if (
          state.neuroMotorAtual.horizontal_jump &&
          typeof state.neuroMotorAtual.horizontal_jump === 'string'
        ) {
          state.neuroMotorAtual.horizontal_jump = state.neuroMotorAtual.horizontal_jump.replace(
            ',',
            '.',
          )
        }

        if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
          state.avaliacaoId = parseInt(route.params.id)
        }
        store.commit('SET_SPLASH_SCREEN', true)
        if (state.avaliacaoId == 0) {
          context.emit('salvar', state.neuroMotorAtual, 'neuromotor')
        } else {
          state.neuroMotorAtual.student_physical_assessment_id = state.avaliacaoId
          if (state.neuroMotorAtual.id == undefined || state.neuroMotorAtual.id == 0) {
            neuroMotorRepository.NeuroMotorPost(state.neuroMotorAtual).then((response) => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                swal({
                  title: 'Avaliação Neuromotor',
                  text: 'Avaliação neuromotor cadastrada com sucesso!',
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn bg-gradient-success',
                  },
                  buttonsStyling: false,
                })
              }
            })
          } else {
            neuroMotorRepository
              .NeuroMotorPut(state.neuroMotorAtual.id, state.neuroMotorAtual)
              .then((response) => {
                store.commit('SET_SPLASH_SCREEN', false)

                if (response.data.success) {
                  swal({
                    title: 'Avaliação Neuromotor',
                    text: 'Avaliação neuromotor atualizada com sucesso!',
                    icon: 'success',
                    customClass: {
                      confirmButton: 'btn bg-gradient-success',
                    },
                    buttonsStyling: false,
                  })
                }
              })
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    // Funções para formatar os campos de salto
    const formatarSaltoVertical = (event, campo) => {
      let value = event.target.value

      // Remove tudo exceto números e vírgula
      value = value.replace(/[^\d,]/g, '')

      // Garante que só tenha uma vírgula
      const parts = value.split(',')
      if (parts.length > 2) {
        value = parts[0] + ',' + parts.slice(1).join('')
      }

      // Limita a 2 casas decimais após a vírgula
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + ',' + parts[1].substring(0, 2)
      }

      // Limita a 4 dígitos antes da vírgula (máximo 9999 cm = 99,99 m)
      if (parts[0].length > 4) {
        value = parts[0].substring(0, 4) + (parts[1] ? ',' + parts[1] : '')
      }

      state.neuroMotorAtual[campo] = value
    }

    const formatarSaltoHorizontal = (event, campo) => {
      let value = event.target.value

      // Remove tudo exceto números e vírgula
      value = value.replace(/[^\d,]/g, '')

      // Garante que só tenha uma vírgula
      const parts = value.split(',')
      if (parts.length > 2) {
        value = parts[0] + ',' + parts.slice(1).join('')
      }

      // Limita a 2 casas decimais após a vírgula
      if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + ',' + parts[1].substring(0, 2)
      }

      // Limita a 4 dígitos antes da vírgula (máximo 9999 cm = 99,99 m)
      if (parts[0].length > 4) {
        value = parts[0].substring(0, 4) + (parts[1] ? ',' + parts[1] : '')
      }

      state.neuroMotorAtual[campo] = value
    }

    // Funções para calcular diferenças convertendo vírgula para ponto
    const calcularDiferenca = (atual, anterior) => {
      if (!atual || !anterior) return 0
      const atualNum = parseFloat(atual.toString().replace(',', '.')) || 0
      const anteriorNum = parseFloat(anterior.toString().replace(',', '.')) || 0
      return (atualNum - anteriorNum).toFixed(2)
    }

    const calcularDiferencaPrimeiro = (atual, primeiro) => {
      if (!atual || !primeiro) return 0
      const atualNum = parseFloat(atual.toString().replace(',', '.')) || 0
      const primeiroNum = parseFloat(primeiro.toString().replace(',', '.')) || 0
      return (atualNum - primeiroNum).toFixed(2)
    }

    const showChart = ref(false)
    const neuroChartCanvas = ref(null)
    let chartInstance = null

    const showTimeChart = ref(false)
    const timeChartCanvas = ref(null)
    let timeChartInstance = null

    function parseJumpValue(val) {
      if (!val) return 0
      return parseFloat(val.toString().replace(',', '.')) || 0
    }

    watch(showChart, async (val) => {
      if (val) {
        await nextTick()
        renderNeuroChart()
      } else {
        if (chartInstance) {
          chartInstance.destroy()
          chartInstance = null
        }
      }
    })

    function renderNeuroChart() {
      if (!neuroChartCanvas.value) return
      if (chartInstance) chartInstance.destroy()
      const ctx = neuroChartCanvas.value.getContext('2d')

      const fields = [
        { key: 'free_vertical_jump', label: 'S. Vertical Livre (cm)' },
        { key: 'vertical_box_jump', label: 'S. Vertical Caixa (cm)' },
        { key: 'horizontal_jump', label: 'S. Horizontal (m)' },
      ]
      const labels = fields.map(f => f.label)
      const dataAtual = fields.map(f => parseJumpValue(state.neuroMotorAtual[f.key]))
      const dataPrimeira = fields.map(f => parseJumpValue(state.neuroMotorPrimeiro[f.key]))
      const dataAnterior = fields.map(f => parseJumpValue(state.neuroMotorAnterior[f.key]))

      chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            { label: 'Atual', data: dataAtual, backgroundColor: '#F7941D', borderColor: '#F7941D', borderWidth: 2, borderRadius: 6 },
            { label: 'Primeira', data: dataPrimeira, backgroundColor: '#2D3A7C', borderColor: '#2D3A7C', borderWidth: 2, borderRadius: 6 },
            { label: 'Anterior', data: dataAnterior, backgroundColor: '#7B8ABF', borderColor: '#7B8ABF', borderWidth: 2, borderRadius: 6 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { size: 13, weight: 'bold' }, padding: 16, usePointStyle: true, pointStyle: 'circle' } },
            tooltip: { backgroundColor: '#2D3A7C', cornerRadius: 8, padding: 10 }
          },
          scales: {
            y: { beginAtZero: true, grid: { color: 'rgba(45,58,124,0.08)' }, ticks: { font: { size: 11 }, color: '#344767' } },
            x: { grid: { display: false }, ticks: { font: { size: 10, weight: 'bold' }, color: '#2D3A7C' } }
          }
        }
      })
    }

    function parseTimeToSeconds(val) {
      if (!val) return 0
      const str = val.toString().trim()
      if (str.includes(':')) {
        const parts = str.split(':')
        const mins = parseInt(parts[0]) || 0
        const secs = parseInt(parts[1]) || 0
        return mins * 60 + secs
      }
      return parseFloat(str) || 0
    }

    function formatSecondsLabel(secs) {
      if (secs === 0) return '00:00'
      const m = Math.floor(secs / 60)
      const s = secs % 60
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
    }

    watch(showTimeChart, async (val) => {
      if (val) {
        await nextTick()
        renderTimeChart()
      } else {
        if (timeChartInstance) {
          timeChartInstance.destroy()
          timeChartInstance = null
        }
      }
    })

    function renderTimeChart() {
      if (!timeChartCanvas.value) return
      if (timeChartInstance) timeChartInstance.destroy()
      const ctx = timeChartCanvas.value.getContext('2d')

      const fields = [
        { key: '50m', label: '50m' },
        { key: '60m', label: '60m' },
        { key: '100m', label: '100m' },
        { key: '200m', label: '200m' },
        { key: '300m', label: '300m' },
        { key: '400m', label: '400m' },
        { key: '600m', label: '600m' },
        { key: '800m', label: '800m' },
        { key: '1000m', label: '1000m' },
        { key: '1500m', label: '1500m' },
        { key: '5000m', label: '5000m' },
      ]
      const labels = fields.map(f => f.label)
      const dataAtual = fields.map(f => parseTimeToSeconds(state.neuroMotorAtual[f.key]))
      const dataPrimeira = fields.map(f => parseTimeToSeconds(state.neuroMotorPrimeiro[f.key]))
      const dataAnterior = fields.map(f => parseTimeToSeconds(state.neuroMotorAnterior[f.key]))

      timeChartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            { label: 'Atual', data: dataAtual, backgroundColor: '#F7941D', borderColor: '#F7941D', borderWidth: 2, borderRadius: 6 },
            { label: 'Primeira', data: dataPrimeira, backgroundColor: '#2D3A7C', borderColor: '#2D3A7C', borderWidth: 2, borderRadius: 6 },
            { label: 'Anterior', data: dataAnterior, backgroundColor: '#7B8ABF', borderColor: '#7B8ABF', borderWidth: 2, borderRadius: 6 }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { size: 13, weight: 'bold' }, padding: 16, usePointStyle: true, pointStyle: 'circle' } },
            tooltip: {
              backgroundColor: '#2D3A7C',
              cornerRadius: 8,
              padding: 10,
              callbacks: {
                label: function(context) {
                  return context.dataset.label + ': ' + formatSecondsLabel(context.raw)
                }
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              grid: { color: 'rgba(45,58,124,0.08)' },
              ticks: {
                font: { size: 11 },
                color: '#344767',
                callback: function(value) { return formatSecondsLabel(value) }
              },
              title: { display: true, text: 'Tempo (MM:SS)', color: '#2D3A7C', font: { size: 12, weight: 'bold' } }
            },
            x: { grid: { display: false }, ticks: { font: { size: 10, weight: 'bold' }, color: '#2D3A7C' } }
          }
        }
      })
    }

    return {
      state,
      salvar,
      formatarSaltoVertical,
      formatarSaltoHorizontal,
      calcularDiferenca,
      calcularDiferencaPrimeiro,
      showChart,
      neuroChartCanvas,
      showTimeChart,
      timeChartCanvas,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.neuro-table thead td,
.neuro-table thead th {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
  color: #fff !important;
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 8px;
  border-color: #354585 !important;
}
.neuro-table tbody td {
  padding: 8px 8px;
  vertical-align: middle;
  color: #344767;
  font-size: 0.85rem;
}
.neuro-table tbody tr:nth-child(even) {
  background: #f0f2f7;
}
.neuro-table tbody tr:nth-child(odd) {
  background: #fff;
}
.neuro-table tbody tr:hover {
  background: #ebeff5;
}
.neuro-table tbody td.text-start {
  font-weight: 600;
  color: #2D3A7C;
}
.neuro-input {
  border: 2px solid #2D3A7C !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  color: #2D3A7C !important;
  text-align: center;
  background: #edf0f6 !important;
  transition: all 0.2s;
}
.neuro-input:focus {
  border-color: #F7941D !important;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.2) !important;
  background: #fff !important;
}
.neuro-saltos-header td {
  background: linear-gradient(135deg, #F7941D 0%, #f5a623 100%) !important;
  color: #fff !important;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.neuro-saltos-header td .font-weight-bold {
  color: #fff;
}
.neuro-saltos-header td .small {
  color: rgba(255, 255, 255, 0.8);
}
/* Chart button on saltos header (orange bar) */
.btn-chart-toggle-saltos {
  background: rgba(255,255,255,0.25);
  border: 2px solid rgba(255,255,255,0.6);
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  vertical-align: middle;
}
.btn-chart-toggle-saltos:hover {
  background: #fff;
  color: #F7941D;
  border-color: #fff;
  box-shadow: 0 2px 8px rgba(255,255,255,0.4);
}
/* Chart button inline */
.btn-chart-toggle-sm {
  background: #F7941D;
  border: none;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  vertical-align: middle;
  box-shadow: 0 2px 6px rgba(247,148,29,0.3);
}
.btn-chart-toggle-sm:hover {
  background: #e5850f;
  transform: scale(1.1);
}
/* Chart overlay/modal */
.chart-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
}
.chart-modal {
  background: #fff;
  border-radius: 16px;
  width: 92%;
  max-width: 800px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  overflow: hidden;
  animation: chartSlideIn 0.3s ease;
}
@keyframes chartSlideIn {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
.chart-modal-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-chart-close {
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.btn-chart-close:hover {
  background: #F7941D;
}
.chart-modal-body {
  padding: 24px;
  height: 400px;
}
</style>
